import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationService {
  constructor(
    private translateService: TranslateService
  ) { }

  async getTranslation(key: string, params?: { [key: string]: any}) {
    return await this.translateService.get(key, params).toPromise();
  }

  getTranslationSync(key: string) {
    return this.translateService.instant(key);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/translation.service.ts